/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-11-17 16:47:19
 */
import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { _session } from "@/utils/modules/storage";
import { getLang,clearAllCookie } from "@/utils/auth";
import i18n from "@/assets/lang";
import router from "../router";
// create an axios instance
const service = axios.create({
  // baseURL: '', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 6000 * 10 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers["appId"] = 1;
    // config.headers["RefreshToken"] = getRefreshToken();
    if (store.getters.tenantId) { config.headers["tenantId"] = store.getters.tenantId; }
    if (store.getters.infoData) { config.headers["belongOrgId"] = store.getters.infoData.belongOrgId; }
    if (store.getters.tenantData) {
      const tenantSource = store.getters.tenantData.tenantSource === "LOCAL" ? 2 : 1;
      config.headers["tenantSource"] = tenantSource;
    }
    if (getLang() === "en") {
      config.headers["Accept-Language"] = "en-US,en;q=0.9";
    } else {
      config.headers["Accept-Language"] = "zh-CN,zh;q=0.9";
    }

    let { url } = config;
    // get参数编码
    if (config.method === "get" && config.params) {
      if (url.includes("?")) {
        url += "&";
      } else {
        url += "?";
      }
      const keys = Object.keys(config.params);
      for (const key of keys) {
        url += `${encodeURIComponent(key)}=${encodeURIComponent(config.params[key])}&`;
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
    }
    config.url = url;

    return config;
  },
  error => Promise.reject(error)
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (response.status !== 200) {
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error(res.message || "Error"));
    } else if (res.success || res.success === undefined) {
      let filename = response.headers["content-disposition"];
      if (filename) {
        filename = decodeURIComponent(filename.split("filename=")[1]);
        return {
          filename,
          data: res
        };
      }
      return res;
    } else {
      if (res.code === 401 || res.code === 600) {
        Message.closeAll();
        // Message.error({
        //   message: res.message || res.msg || 'Error',
        //   duration: 3 * 1000
        // });
        clearAllCookie();
        router.push({ path: "/login" });
        return;
      } else {
        Message.error({
          message: res.message || res.msg || "Error",
          duration: 3 * 1000
        });
      }
      return Promise.reject(new Error(res.message || res.msg || "Error"));
    }
  },
  error => {
    if (error.request.responseType === "blob") {
      Message.closeAll();
      Message({
        message: i18n.t("public.serviceBusy"),
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(error);
    } else {
      // response可能为空字符串，JSON.parse转换出错
      const responseError = error.request.response;
      const response = responseError && JSON.parse(responseError);
      if (response && response.resultCode === 401) {
        location.reload();
      }
      Message.closeAll();
      Message({
        message: response.msg || i18n.t("public.serviceBusy"),
        type: "error",
        duration: 5 * 1000
      });
      _session.remove("setPwToken");
      return Promise.reject(error);
    }
  }
);

export default service;
